core.component('coreLoadingComponent', {
    templateUrl: 'components/loading/loading.html'
});